import { useParams } from 'next/navigation'
import type { RoutingLocale } from '@/utils/l10n/types'

// Separate hook needed for app router because next/navigation is used instead of next/router
export const useAppRouterLocale = () => {
  const { locale } = useParams<{ locale: RoutingLocale }>()
  return locale
}
